import React from 'react'

import { Footer as CreditasLabFooter } from '@creditas-lab/footer'

import { config } from './constants/config'

const Footer = () => <CreditasLabFooter config={config} />

export { Footer }
